import { useContext } from "react";
import { ActiveHospitalContext } from ".";

export const useActiveHospital = () => useContext(ActiveHospitalContext);
